import Base from "@/controllers/base";
export default class Container extends Base {
  constructor(elem) {
    super(elem);
  }

  init() {
    super.init();
    this.drayageMode();
    this.autoHideGridItems();
    this.highlightCharges();
    this.sslineBookingNo();
    this.showForm();
  }

  form() {
    return this.elem.querySelector("form");
  }

  drayageMode(event) {
    const form = event?.target.closest("form") || this.form();
    if (!form) return;
    const checked = form.querySelector(
      'input[name="container[drayage_mode]"]:checked',
    );
    const mode = checked?.value || form.dataset.drayageMode;
    if (!mode) return;
    form.querySelectorAll("[data-drayage]").forEach((row) => {
      row.classList.toggle("hidden", row.dataset.drayage !== mode);
    });
    if (event) this.initState(event);
  }

  autoHideGridItems() {
    [".grid-line .grid-detail", ".grid-line .grid-input"].forEach(
      (selector) => {
        let previous = {};
        this.elem.querySelectorAll(selector).forEach((item, index) => {
          let empty = item.childNodes.length == 0;
          if (empty && previous.empty) {
            previous.item.style.display = "none";
            item.style.display = "none";
          }
          previous = (index + 1) % 2 == 1 ? { item, empty } : {};
        });
      },
    );
  }

  highlightCharges() {
    this.elem.addEventListener("mouseover", (event) => {
      const detail = event.target.closest(".operation-detail");
      if (detail) {
        const id = detail.id;
        document.querySelectorAll(`tr[class~="highlight"]`).forEach((tr) => {
          tr.classList.remove("highlight");
        });
        document.querySelectorAll(`tr[class~="${id}"]`).forEach((tr) => {
          tr.classList.add("highlight");
        });
      }
    });
  }

  async sslineBookingNo() {
    const copyIcon = this.elem.querySelector(".copy-ssline-booking-no");
    if (copyIcon) {
      const sourceSelector = "[name='container[ssline_booking_no]']";
      const destSelector = "[name='container[empty_release_no]']";
      const source = this.elem.querySelector(sourceSelector);
      const dest = this.elem.querySelector(destSelector);
      copyIcon.addEventListener("click", () => {
        dest.value = source.value;
        dest.dispatchEvent(new Event("change"));
      });
      copyIcon.addEventListener("mouseover", () => source.classList.add("hl"));
      copyIcon.addEventListener("mouseout", () =>
        source.classList.remove("hl"),
      );
    }
  }

  showForm() {
    const form = this.form();
    if (form) form.classList.remove("hidden");
  }

  async initState(event) {
    try {
      const form = event.target.closest("form");
      const formData = new FormData(form);
      [...formData.keys()]
        .filter((key) => /_charges|_method/i.test(key))
        .forEach((key) => formData.delete(key));
      const response = await fetch("/containers/init", {
        method: "POST",
        body: formData,
      });
      const { state } = await response.json();
      const preAlertBtn = document.querySelector("input.pre-alert");
      const confirmedBtn = document.querySelector("input.confirmed");
      preAlertBtn.show();
      confirmedBtn.hide();
      if (state == "confirmed") {
        preAlertBtn.hide();
        confirmedBtn.show();
      }

      if (event.target.id == "container_rail_lfd") {
        setTimeout(
          () =>
            window.dispatchEvent(
              new CustomEvent("CheckPrepull", {
                detail: { target: event.target },
              }),
            ),
          250,
        );
      }
    } catch (ex) {
      console.log(ex);
    }
  }
  async clearFields(event) {
    try {
      const form = event.target.closest("form");
      form.querySelectorAll(".clearable-field").forEach((field) => {
        field.value = "";
        field.dispatchEvent(new Event("change"));
      });
    } catch (ex) {
      console.log(ex);
    }
  }

  async hoverSubmit(event) {
    try {
      const form = event.target.closest("form");
      form.removeAttribute("novalidate");
      if (event.target.classList.contains("draft")) {
        form.setAttribute("novalidate", true);
      }
    } catch (ex) {}
  }

  async customerChanged(event) {
    try {
      const input = event.target;
      let ov = parseInt(input.getAttribute("origin") || "0");
      let nv = parseInt(input.value || "0");
      const orderType = document.getElementById("order_type").value;
      const response = await fetch(
        `/customers/${nv}/contacts?order_type=${orderType}`,
      );
      const contacts = input.closest("form").querySelector(".contacts");
      contacts.innerHTML = await response.text();
      NApp.dispatchTurboLoad();
      this.init();

      if (window.ReceivableChargeForm) {
        ReceivableChargeForm.setCustomerId(nv);
        const nums = ReceivableChargeForm.numCharges(ov);
        if (nums > 0) {
          let msg = `Would you like to apply the current ${nums} charges to new customer?`;
          if (confirm(msg)) {
            if (ov === 0) ov = null;
            if (nv === 0) nv = null;
            ReceivableChargeForm.updateCompany(ov, nv);
          } else {
            ReceivableChargeForm.deleteCharges("company_id", ov);
          }
        }
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  async contactChanged(event) {
    try {
      const input = event.target;
      const form = input.closest("form");
      const id = form.querySelector("[name='container[customer_id]']").value;
      const cid = form.querySelector("[name='container[contact_id]']").value;
      const cid2 = form.querySelector("[name='container[contact2_id]']").value;
      if (parseInt(id) > 0) {
        const response = await fetch(
          `/customers/${id}/contacts?selected=${cid},${cid2}`,
        );
        const contacts = input.closest("form").querySelector(".contacts");
        contacts.innerHTML = await response.text();
        NApp.dispatchTurboLoad();
        this.init();
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  chassisSelected(event) {
    const detail = event.detail;
    if (!detail || typeof detail !== "object") return;
    this.applyChassisField(detail.stencil, "chassis_stencil");
    this.applyChassisField(detail.stype, "chassis_type");
  }

  applyChassisField(value, column) {
    const text = (value || "").toString().trim();
    if (!text) return;
    const selector1 = `[name="container[${column}]"]`;
    const selector2 = `[name="${column}"]`;
    let input = this.elem.querySelector(selector1);
    input ||= this.elem.querySelector(selector2);
    if (!input) return;
    input.dispatchEvent(
      new CustomEvent("update", {
        detail: { value: text },
        bubbles: true,
      }),
    );
  }

  async checkDup(event) {
    try {
      const input = event.target;
      const value = input.value || input.dataset.val;
      const parentSelector = input.dataset.parent;
      const response = await fetch(`${input.dataset.url}&term=${value}`);
      const { html } = await response.json();
      const parentElement = parentSelector
        ? input.closest(parentSelector)
        : input.parentElement;
      let warning = parentElement.querySelector(".dups-warning");
      if (warning) warning.remove();
      if (html != "") {
        warning = document.createElement("div");
        warning.classList.add("dups-warning", "red");
        warning.innerHTML = html;
        parentElement.appendChild(warning);
      }
    } catch (ex) {}
  }

  static refresh(id) {
    try {
      setTimeout(() => {
        let link = document.querySelector(`#o${id}r`);
        if (link) {
          link.click();
        } else {
          let regexp = new RegExp(`containers/${id}`);
          if (regexp.test(window.location.href)) {
            window.location.reload();
          }
        }
      }, 50);
    } catch (ex) {}
  }

  static mileages(data) {
    for (var item of data) {
      var elem = document.getElementById(`m${item.id}`);
      if (elem) elem.innerText = item.miles || "";
    }
  }

  static reloadContacts(value, cids) {
    try {
      cids.forEach((cid) => {
        const select = document.querySelector(`.customer-${cid}-contact`);
        if (select) {
          select.value = value;
          select.dispatchEvent(new Event("change"));
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  }

  static async cacheOrder(source) {
    try {
      const token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
      const orderForm = source.closest("form");
      if (orderForm) {
        await fetch("/containers/cache", {
          method: "POST",
          headers: {
            "X-CSRF-Token": token,
          },
          body: new FormData(orderForm),
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  static movePlate(event) {
    const link = event.target;
    const plate = link.closest(".plate");
    const orderRight = document.querySelector(".order-right");
    plate.style.margin = "0";
    plate.style.position = "relative";
    orderRight.prepend(plate);
    if (link.dataset.frame) {
      NApp.resizeModal(link.dataset.frame, { width: 1565 });
    }
  }
}
